import { render, staticRenderFns } from "./FForm.vue?vue&type=template&id=afc5d2f6&"
import script from "./FForm.vue?vue&type=script&lang=js&"
export * from "./FForm.vue?vue&type=script&lang=js&"
import style0 from "./FForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports